import Color from 'color'

/**
 * 从 CSS 变量中读取主色（# 格式）
 */
function getPrimaryColorFromCSS(): string {
  const rootStyles = getComputedStyle(document.documentElement)
  const value = rootStyles.getPropertyValue('--color-primary-500').trim()

  if (value.startsWith('#')) {
    return value
  }

  console.warn(`无法解析主题色: ${value}，使用默认色 #ff4f4f`)
  return '#ff4f4f'
}

/**
 * 生成 Element Plus 主题色阶
 */
export function generateElementPlusTheme(hexColor: string) {
  const baseColor = Color(hexColor)
  const isLight = baseColor.isLight()

  const colors: Record<string, string> = {}
  for (let i = 1; i <= 9; i++) {
    const key = `--el-color-primary-light-${i}`
    if (isLight) {
      colors[key] = baseColor.mix(Color('white'), 0.1 * (10 - i)).hex()
    } else {
      colors[key] = baseColor.mix(Color('white'), 0.1 * i).hex()
    }
  }

  const dark2 = baseColor.darken(0.1).hex()

  return {
    '--el-color-primary': hexColor,
    '--el-color-primary-dark-2': dark2,
    '--el-color-primary-light-3': colors['--el-color-primary-light-3'],
    '--el-color-primary-light-5': colors['--el-color-primary-light-5'],
    '--el-color-primary-light-7': colors['--el-color-primary-light-7'],
    '--el-color-primary-light-8': colors['--el-color-primary-light-8'],
    '--el-color-primary-light-9': colors['--el-color-primary-light-9'],
  }
}

/**
 * 应用 Element Plus 主题变量到 :root
 */
export function applyElementPlusTheme() {
  const primaryHex = getPrimaryColorFromCSS()
  const theme = generateElementPlusTheme(primaryHex)
  const root = document.documentElement

  Object.entries(theme).forEach(([key, value]) => {
    root.style.setProperty(key, value)
  })
}

/**
 * 初始化主题（在 main.ts 中调用一次）
 */
export function initTheme() {
  applyElementPlusTheme()
}
